module.exports = __webpack_public_path__ + "img/dgjg2333_1.ed86d8c5.svg";